import { createLowlight } from 'lowlight';

export const lowlight = createLowlight({});
